// jsErrorLogger.js

(function () {
    const ENDPOINT = 'https://book.ontimeagenda.com/log-js-error';

    function sendErrorLog(errorData) {
        try {
            fetch(ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify(errorData),
            });
        } catch (e) {
            // Silently fail (avoid logging errors from this logger itself)
        }
    }

    function extractErrorInfo({ message, filename, lineno, colno, error }) {
        const stack = error?.stack || '';
        if (!stack.includes('booking-widget.min.js')) return;

        sendErrorLog({
            message: message || 'Script error',
            file: filename || null,
            line: lineno || null,
            column: colno || null,
            stack,
            user_agent: navigator.userAgent,
        });
    }

    function handleUnhandledRejection(event) {
        const reason = event.reason || {};
        const stack = reason.stack || '';

        if (!stack.includes('booking-widget.min.js')) return;

        sendErrorLog({
            message: reason.message || 'Unhandled promise rejection',
            file: null,
            line: null,
            column: null,
            stack,
            user_agent: navigator.userAgent,
        });
    }

    window.addEventListener('error', extractErrorInfo, true);
    window.addEventListener('unhandledrejection', handleUnhandledRejection, true);
})();
